var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconFireColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DD2C00",
    d: "M22.368 15.132c0 5.523-4.346 9.868-9.869 9.868s-9.867-4.345-9.867-9.868C2.632 9.609 11.499 5 10.499 0 12.5 0 22.37 7.132 22.37 15.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5722",
    d: "M18.421 17.763c0-5-5.921-9.868-5.921-9.868 0 4-5.921 5.869-5.921 9.868 0 3.313 2.607 5.921 5.921 5.921s5.921-2.608 5.921-5.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M9.21 20.004c0-2.24 3.29-3.523 3.29-5.53 0 0 3.289 2.52 3.289 5.53 0 1.661-1.472 3.01-3.29 3.01-1.817 0-3.29-1.348-3.29-3.01z"
  }))));
}

export default SvgCommonIconFireColor;